import axios from 'axios';


export default {
    find: function(query) {
        return axios.post(`proxy.php?/layouts/user-login/_find`, query)
        .then((response)=>{
            return response.data
        })
        .catch((e)=>{
            if(e.response.data.messages[0].message){
                //Return FM Error Response
                return e.response.data
            }
            else{
                //Format Unknown Error Like a FM Error
                return  `{ messages:[message: ${e.message}, code: -1],response: {}}`;
            }
        })
    },
    
    updateRecord: function(fieldData, recordID) {
        return axios.patch(`proxy.php?/layouts/user-login/records/${recordID}`, fieldData)
        .then((response)=>{
            return response.data
        })
        .catch((e)=>{
            if(e.response.data.messages[0].message){
                //Return FM Error Response
                return e.response.data
            }
            else{
                //Format Unknown Error Like a FM Error
                return  `{ messages:[message: ${e.message}, code: -1],response: {}}`
            }
        })
    },
    
    createUser: function(fieldData){
        return axios.post(`proxy.php?/layouts/user-login/records`, fieldData)
        .then((response)=>{
            return response.data
        })
        .catch((e)=>{
            if(e.response.data.messages[0].message){
                //Return FM Error Response
                return e.response.data
            }
            else{
                //Format Unknown Error Like a FM Error
                return  `{ messages:[message: ${e.message}, code: -1],response: {}}`
            }
        })
    },
    loadPackages: function(params){
        return axios.post(`loadPackages.php`, params)
        .then((response)=>{
            return response.data
        })
        .catch((e) =>{
            if(e.response.data.messages[0].message){
                return null
            }
            else{
                return null
            }
        })
    },

    loadAdminAccounts: function(accountID){
        return axios.post(`loadAdminUsers.php`, accountID)
        .then((response)=>{
            return response.data
        })
        .catch((e) =>{
            if(e.response.data.messages[0].message){
                return null
            }
            else{
                return null
            }
        })
    },

    loadUserAccounts: function(accountID){
        return axios.post(`loadUserAccounts.php`, accountID)
        .then((response)=>{
            return response.data
        })
        .catch((e) =>{
            if(e.response.data.messages[0].message){
                return null
            }
            else{
                return null
            }
        })
    },

    loadspecificUserAccounts: function(adminAccountID){
        return axios.post(`loadSpecificUserAccounts.php`, adminAccountID)
        .then((response)=>{
            return response.data
        })
        .catch((e) =>{
            if(e.response.data.messages[0].message){
                return null
            }
            else{
                return null
            }
        })
    },
}